// ACControlList.tsx
import React from 'react';
import './blockStyle.css';
import { ACControlItem } from '../types';

interface ACControlListProps {
  items: ACControlItem[];
  maxControllers?: number;
}

const ACControlList: React.FC<ACControlListProps> = ({ items, maxControllers = 15 }) => {
  // Преобразуем массив в объект: { адрес → версия }
  const acMap = items.reduce<Record<number, string>>((acc, item) => {
    acc[item.controller_address] = item.acVersion;
    return acc;
  }, {});

  // Генерируем строки от 1 до maxControllers
  const rows = Array.from({ length: maxControllers }, (_, i) => {
    const addr = i + 1;
    const version = acMap[addr] ? acMap[addr] : '---';
    return (
      <div key={addr} className="FW-field-row ac-control-row">
        <div className="FW-field">
          <span className="ac-control-text">
            AC_Control, addr {addr}  {version}
          </span>
        </div>
      </div>
    );
  });

  return (
    <div className="FW-update-block ac-control-block">
      <h3>AC Controls</h3>
      <div className="FW-ac-list-rows">{rows}</div>
    </div>
  );
};

export default ACControlList;
